import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'

import messages from './messages'
import s from './BeautyBag.scss'


class BeautyBagNotification extends PureComponent {

  static contextTypes = {
    close: PropTypes.func,
  }

  handleClick = () => {
    const { close } = this.context
    const { onClose } = this.props

    close()

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { image, stepsLeft } = this.props

    let titleMessage = messages.bestOffer
    let offerMessage = messages.getFree
    let actionMessage = {
      ...messages.addMore,
      values: {
        count: stepsLeft,
      },
    }

    if (stepsLeft === 1) {
      titleMessage = messages.almostThere
    }

    if (stepsLeft === 0) {
      titleMessage = messages.yay
      offerMessage = messages.unlocked
      actionMessage = messages.itWasAdded
    }

    return (
      <div className={s.item} onClick={this.handleClick}>
        <div className={s.preview}>
          <Image src={image} alt="preview" w={150} fullWidth x2 x3 />
        </div>
        <Text uppercase message={titleMessage} size="12-16" html />
        <Box mt="4">
          <Text uppercase semibold message={offerMessage} size="14-24" html />
        </Box>
        <Box mt="4">
          <Text message={actionMessage} size="14-24" html />
        </Box>
      </div>
    )
  }
}


export default BeautyBagNotification
